<template>
  <div class="text-dark font-normal text-center w-full">
    <img
      src="/images/success-person.svg"
      alt="Placeholder"
      class="mx-auto"
    />
    <h1 class="sm:text-xl text-lg mt-3 mb-4">
      Success! Welcome to <span class="font-bold">Club+</span>
    </h1>
    <p class="font-bold">
      Club+ will load in few seconds,
    </p>
    <p class="font-bold">
      if not working <span class="cursor-pointer underline" @click="$emit('load-dashboard')">
        click here
      </span>
    </p>
  </div>
</template>

<script setup>
defineOptions({
  name: 'AtomsDashboardAuthSuccessScreen'
})

defineEmits(['load-dashboard'])
</script>

<style scoped>

</style>
